import { safeFetch } from "../utils/safeFetch";



export const getAllCategorie = async (token, tenant, { includeInactive = false } = {}) => {
  const query = includeInactive ? '?includeInactive=true' : '';
  const response = await safeFetch(`/api/categories${query}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  }, includeInactive ? 'allCategoriesIncludingInactive' : 'allCategories');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const getCategoriaById = async (id, token, tenant) => {
  const response = await safeFetch(`/api/categories/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  }, `category_${id}`);

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const createCategoria = async (category, token, tenant) => {
  const response = await safeFetch(`/api/categories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify(category),
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const updateCategoria = async (id, category, token, tenant) => {
  const response = await safeFetch(`/api/categories/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify(category),
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const reorderCategorie = async (categoryIds, token, tenant) => {
  const response = await safeFetch('/api/categories/reorder', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ categoryIds }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }
  return await response.json();
};

export const getMyCategoryOrder = async (token, tenant) => {
  const response = await safeFetch('/api/categories/my-order', {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const data = await response.json();
  return Array.isArray(data?.categoryIds) ? data.categoryIds : [];
};

export const saveMyCategoryOrder = async (categoryIds, token, tenant) => {
  const response = await safeFetch('/api/categories/my-order', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ categoryIds }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  return Array.isArray(data?.categoryIds) ? data.categoryIds : [];
};

const categoryVisibilityRequest = async (url, token, tenant, options = {}) => {
  const response = await safeFetch(url, {
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getMyCategoryVisibility = (token, tenant) => (
  categoryVisibilityRequest('/api/categories/my-visibility', token, tenant)
);

export const getUserCategoryVisibility = (userId, token, tenant) => (
  categoryVisibilityRequest(`/api/categories/user/${Number(userId)}/visibility`, token, tenant)
);

export const saveUserCategoryVisibility = (userId, visibleCategoryIds, orderedCategoryIds, token, tenant) => (
  categoryVisibilityRequest(`/api/categories/user/${Number(userId)}/visibility`, token, tenant, {
    method: 'PUT',
    body: JSON.stringify({ visibleCategoryIds, orderedCategoryIds }),
  })
);

export const deleteCategoria = async (id, token, tenant) => {
  const response = await safeFetch(`${"/api/categories"}/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  });

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    try {
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  } catch (err) {
    console.warn("Risposta non JSON:", err);
    return null;
  }
};

export const deleteCategorie = async (categoryIds, token, tenant) => {
  const response = await safeFetch('/api/categories/bulk-delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify({ categoryIds }),
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error('Impossibile connettersi al server');
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || error.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};
